export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13855.a1ab3e02.jpg";